export default __webpack_public_path__ + "static/media/sessionTimeOut.a19f7d29.svg";